import { Stack, Typography } from "@mui/material";
import { IOrder, IOrderOffer } from "../interface/IOrder";
import { useTranslation } from "react-i18next";
import { ConfirmationModal } from "@common/ConfirmationModal/ConfirmationModal";
import { useOrderOffer } from "./useOrderOffer";
import { CancelButton } from "./CancelButton";
import { TCancelOrder } from "../type/TCancelOrder";

interface IParams {
    cancelOrder?: TCancelOrder;
    offer: IOrderOffer;
    orderReference: IOrder["reference"];
}

export const OrderOffer = (props: IParams) => {
    const {
        cancelOrder,
        offer: { name, isEligibleToCancel, oneOffChargeAmount, upFrontChargeAmount },
        orderReference,
    } = props;
    const { t } = useTranslation(["common", "order"]);
    const {
        cancelBroadbandOrder,
        displayCancelButton,
        isCancelModalOpen,
        isLoading,
        isMobile,
        setIsCancelModalOpen,
    } = useOrderOffer({
        cancelOrder,
        isEligibleToCancel,
        orderReference,
    });

    return (
        <>
            <Stack direction="row" spacing={isMobile ? 2 : 8}>
                <Stack direction={isMobile ? "column" : "row"} flex={1} justifyContent="space-between">
                    <Typography color="secondary" fontWeight={900} variant="large">
                        {name}
                    </Typography>
                    {cancelOrder && displayCancelButton && <CancelButton onClick={() => setIsCancelModalOpen(true)} />}
                </Stack>
                {upFrontChargeAmount + oneOffChargeAmount !== 0 && (
                    <Typography color="primary" fontWeight={900} variant="large">
                        {t("common:price", {
                            price: upFrontChargeAmount + oneOffChargeAmount,
                        })}
                    </Typography>
                )}
            </Stack>
            {cancelOrder && (
                <ConfirmationModal
                    cancelLabel={t("order:cancelModalCancel")}
                    continueLabel={t("order:cancelModalContinue")}
                    isLoading={isLoading}
                    isModalOpen={isCancelModalOpen}
                    subtitle={t("order:cancelModalSubtitle")}
                    title={t("order:cancelModalTitle")}
                    onClose={() => setIsCancelModalOpen(false)}
                    onContinue={cancelBroadbandOrder}
                />
            )}
        </>
    );
};
